import './hero-banner.scss';
import React, { useLayoutEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const HeroBanner: React.FC = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const title3Ref = useRef<HTMLDivElement>(null);
  const title2Ref = useRef<HTMLDivElement>(null);

  const isInstagramInApp = () => {
    if (typeof window === 'undefined') return false;
    const ua = navigator.userAgent || navigator.vendor;
    return ua.includes('Instagram');
  };

  const isIG = isInstagramInApp();

  // 🔒 FREEZE HEIGHT su Instagram
  useLayoutEffect(() => {
    if (!isIG) return;
    if (!sectionRef.current) return;

    const height = sectionRef.current.offsetHeight;

    sectionRef.current.style.height = `${height}px`;
    sectionRef.current.style.minHeight = `${height}px`;

    // sicurezza extra per GSAP
    requestAnimationFrame(() => {
      ScrollTrigger.refresh(true);
    });
  }, [isIG]);

  // 🎬 GSAP
  useLayoutEffect(() => {
    if (window.innerWidth <= 1024) return;

    const ctx = gsap.context(() => {
      gsap.fromTo(
        title3Ref.current,
        { y: 0 },
        {
          y: -200,
          ease: 'none',
          scrollTrigger: {
            trigger: title3Ref.current,
            start: 'top 90%',
            end: 'top 0%',
            scrub: true,
          },
        }
      );

      gsap.fromTo(
        title2Ref.current,
        { y: 0 },
        {
          y: -300,
          ease: 'none',
          scrollTrigger: {
            trigger: title2Ref.current,
            start: 'top 70%',
            end: 'top 0%',
            scrub: true,
          },
        }
      );
    });

    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="hero flex flex-col justify-between bg-dark text-light px-6 py-7"
    >
      {/* Titolo superiore */}
      <div className="title-1-wrapper">
        <h3 className="title-1 overflow-hidden">
          {'Product'.split('').map((char, index) => (
            <span
              className="animate-text-reveal inline-block [animation-fill-mode:backwards]"
              key={`${char}-${index}`}
              style={{ animationDelay: `${index * 0.06}s` }}
            >
              {char === ' ' ? '\u00A0' : char}
            </span>
          ))}
        </h3>
        <h3 className="title-1 overflow-hidden">
          {'Designer'.split('').map((char, index) => (
            <span
              className="animate-text-reveal inline-block [animation-fill-mode:backwards]"
              key={`${char}-${index}`}
              style={{ animationDelay: `${index * 0.06}s` }}
            >
              {char === ' ' ? '\u00A0' : char}
            </span>
          ))}
        </h3>
      </div>

      {/* Parte inferiore */}
      <div className="flex flex-col-reverse lg:flex-row justify-between items-end gap-5">
        <h5 className="title-3 text-light-70" ref={title3Ref}>
          iF Design Award 2026 Winner
        </h5>

        <div ref={title2Ref} className="title-2-wrapper">
          <h4 className="title-2 text-right overflow-hidden">
            {'Alessandro'.split('').map((char, index) => (
              <span
                className="animate-text-reveal inline-block [animation-fill-mode:backwards]"
                key={`${char}-${index}`}
                style={{ animationDelay: `${index * 0.06}s` }}
              >
                {char === ' ' ? '\u00A0' : char}
              </span>
            ))}
          </h4>

          <h4 className="title-2 text-right overflow-hidden">
            {'Serra'.split('').map((char, index) => (
              <span
                className="animate-text-reveal inline-block [animation-fill-mode:backwards]"
                key={`${char}-${index}`}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {char === ' ' ? '\u00A0' : char}
              </span>
            ))}
          </h4>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;